import enUS from '@i18n/buygather/en-US.json'
import zhTW from '@i18n/buygather/zh-TW.json'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const resources = {
  'zh-TW': {
    translation: zhTW,
  },
  'en-US': {
    translation: enUS,
  },
}

const browserLanguage = navigator.language
  ? navigator.language.startsWith('zh')
    ? 'zh-TW'
    : 'en-US'
  : 'zh-TW'
const language = browserLanguage || 'zh-TW'
const i18nInstance = i18n.createInstance()
i18nInstance
  .use(initReactI18next)
  .init({
    resources,
    lng: language,
    interpolation: {
      escapeValue: false,
    },
    saveMissing: true,
  })

export { i18nInstance }
